import React from 'react';
import clsx from '@strava/ui/clsx';
import { useStravaBranch } from '@strava/container-context';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './FooterUpsell.module.scss';

const FooterUpsell = () => {
  const { state, t, track } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete, authorizationUrls } = athleteData;

  const branch = useStravaBranch();
  const { appLink } = branch;

  const trackClickEvent = (props) => {
    track({
      action: 'click',
      ...props
    });
  };

  return (
    <div className={styles.container}>
      <h3>{t('bottom_cta_header')}</h3>
      <a
        href={appLink}
        className={clsx(styles.btn, styles.btnDownload)}
        onClick={() =>
          trackClickEvent({
            element: 'get_app',
            properties: {
              profile_visibility: getProfileVisibility(athlete),
              cta_copy: 'get_the_app',
              url: appLink
            }
          })
        }
      >
        {t('get_the_app_cta')}
      </a>
      <a
        href={authorizationUrls.facebook}
        className={clsx(styles.btn, styles.btnFacebook)}
        onClick={() =>
          trackClickEvent({
            element: 'facebook_signup',
            properties: {
              profile_visibility: getProfileVisibility(athlete)
            }
          })
        }
      >
        {t('facebook_cta')}
      </a>

      <a
        href={authorizationUrls.google}
        className={clsx(styles.btn, styles.btnGoogle)}
        onClick={() =>
          trackClickEvent({
            element: 'google_signup',
            properties: {
              profile_visibility: getProfileVisibility(athlete)
            }
          })
        }
      >
        {t('google_cta')}
      </a>

      <a
        href={authorizationUrls.email}
        className={clsx(styles.btn, styles.btnEmail)}
        onClick={() =>
          trackClickEvent({
            element: 'start_signup',
            properties: {
              profile_visibility: getProfileVisibility(athlete),
              signup_copy: 'get_strava_2'
            }
          })
        }
      >
        {t('email_cta')}
      </a>
    </div>
  );
};

export default FooterUpsell;
